import React, {memo} from 'react'
import cx from 'classnames'

/* Utils */
import {setWindowScrollTop} from '../../../../../../common/dom/domUtils'
import {yieldToMain} from '../../../../../../utils/performance'

/* Constants */
import {EVENT_BUS_NAMES} from '../../../../../../modules/product/productMobileConstants'
import {DAVINCI_EVENT_NAMES} from '../../../../../../modules/analytics/davinci/davinciConstants'

/* Components */
import DeliveryOptionsContent from '../content/DeliveryOptionsContent'
import InfoMessage from '../info-message/InfoMessage'

/* Styles */
import s from './delivery-options-full.scss'

const DELIVERY_OPTIONS_TYPE = {
  EXPRESS_DELIVERY: 'ExpressDelivery',
  NEXTDAY_DELIVERY: 'NextDayDelivery',
  PEACE_OF_MIND: 'PeaceOfMind',
  STANDARD: 'StandardDelivery',
  SCHEDULED_SAME_DAY_DELIVERY: 'ScheduledSameDayDelivery'
}

const SHIPPING_LOCATION_CLICK_EVENT_KEY = 'shipping.voltran.shippingLocation.listing.click'
const SCROLL_TOP_DURATION = 1000

const DeliveryOptionsFull = memo(({
  dispatch,
  deliveryTooltips,
  buyBoxWinnerDueDate,
  sku,
  listingId,
  merchantId,
  merchantName,
  price,
  hasFasterMerchant,
  location,
  productModel,
  categoryId,
  categoryName
}) => {
  const handleFastDeliveryClick = async() => {
    window?.HbEventBus?.emit(EVENT_BUS_NAMES.FASTER_SELLER_CLICK, true)
    await yieldToMain()
    window?.hepsiBus?.track(DAVINCI_EVENT_NAMES.LINK_CLICK, {
      placement: 'DeliveryOptions',
      location: 'deliveryComponent',
      position: 'Delivery Options',
      text: 'Daha hızlı teslimat yapan satıcılar var',
      url: '',
      page_type: 'pdp',
      page_value: sku,
    })
  }

  const handleLocationOnClick = async() => {
    if (window.HbEventBus) {
      window?.HbEventBus.emit(SHIPPING_LOCATION_CLICK_EVENT_KEY, true)
      await yieldToMain()
      setWindowScrollTop(0, SCROLL_TOP_DURATION)
    }
  }

  const renderInfoMessage = () => {
    if (!location) {
      return (
        <InfoMessage className={s.pointer} iconClassNames={s.infoIcon} onClick={() => handleLocationOnClick()}>
          <b>En hızlı</b> teslimat seçeneklerini ve <b>Hepsimat Noktalarını</b> görmek için <b>konumunu seç</b> ve
          alışverişe başla
        </InfoMessage>
      )
    }

    let deliveryOptionsTypes = buyBoxWinnerDueDate?.deliveryOptions?.map(item => item.type);
    let isPeaceOfMind = deliveryOptionsTypes?.includes(DELIVERY_OPTIONS_TYPE.PEACE_OF_MIND);
    let isStandardDelivery = deliveryOptionsTypes?.includes(DELIVERY_OPTIONS_TYPE.STANDARD);
    let isExpressDelivery = deliveryOptionsTypes?.includes(DELIVERY_OPTIONS_TYPE.EXPRESS_DELIVERY);
    let isNextDayDelivery = deliveryOptionsTypes?.includes(DELIVERY_OPTIONS_TYPE.NEXTDAY_DELIVERY);
    let premiumText = deliveryOptionsTypes?.includes(DELIVERY_OPTIONS_TYPE.SCHEDULED_SAME_DAY_DELIVERY);

    if (hasFasterMerchant && (isPeaceOfMind || isStandardDelivery) && buyBoxWinnerDueDate?.deliveryOptions?.length === 1) {
      return (
        <InfoMessage
          className={cx(s.pointer, s.marginTop)} iconClassNames={s.fastDeliveryIcon}
          onClick={() => handleFastDeliveryClick()} chevronRight>
          {'Daha hızlı teslimat yapan satıcılar var'}
        </InfoMessage>
      )
    }

    return null
  }

  return (
    <div
      className={s.root} data-hbus={JSON.stringify({
        events: {view: ['davinci']},
        data: {
          eventName: 'ComponentView',
          categoryHierarchy: `${categoryId} - ${categoryName}`,
          component: 'Delivery Options',
          component_detail: 'Teslimat Secenekleri',
          dueDateFormatted: buyBoxWinnerDueDate?.dueDateFormatted,
          eadDateFormatted: buyBoxWinnerDueDate?.eadDateFormatted,
          cutOffTime: buyBoxWinnerDueDate?.cutOffTime,
          shipmentTimeAsDays: buyBoxWinnerDueDate?.shipmentTimeAsDays,
          warehouseId: buyBoxWinnerDueDate?.warehouseId,
          isBuyBoxWinner: buyBoxWinnerDueDate?.isBuyBoxWinner,
          currentDate: buyBoxWinnerDueDate?.currentDate,
          isJetDelivery: buyBoxWinnerDueDate?.isJetDelivery,
          isNextDayDelivery: buyBoxWinnerDueDate?.isNextDayDelivery,
          cargoFirmId: buyBoxWinnerDueDate?.cargoFirmId,
          basketDeliveryText: buyBoxWinnerDueDate?.basketDeliveryText,
          dueDateTextReason: buyBoxWinnerDueDate?.dueDateTextReason,
          listing_id: listingId || '',
          dtPredictedDueDate: buyBoxWinnerDueDate?.dtPredictedDueDate || '',
          merchant_id: merchantId || '',
          merchant_name: merchantName,
          page_type: 'pdp',
          position: 1,
          page_value: productModel?.sku || '',
          placement: 'Delivery Options',
          price: `${price}` || '',
          product_id: productModel?.productId || '',
          isFasterMerchant: buyBoxWinnerDueDate?.isFasterMerchant,
          deliveryOptions: buyBoxWinnerDueDate?.deliveryOptions?.map((item) => {
            return {
              delivery_type: item?.type || '',
              delivery_name: item?.optionName || '',
              delivery_text: item?.text || '',
              cargo_firm_id: item?.cargoFirmId?.toString() || ''
            }
          }) || '',
        },
        experiments: buyBoxWinnerDueDate?.experimentInfo?.split('#')?.map((item) => ({
          experimentId: item?.split('|')?.[0],
          variationId: item?.split('|')?.[1],
        })),
        type: 'componentView',
      })}>
        <div className={s.title}>Teslimat Seçenekleri</div>
        <DeliveryOptionsContent
          dispatch={dispatch}
          hasFasterMerchant={hasFasterMerchant}
          deliveryTooltips={deliveryTooltips}
          dueDate={buyBoxWinnerDueDate}
          sku={sku}
          location={location}/>
        {renderInfoMessage()}
    </div>
  )
})

export default DeliveryOptionsFull
